__turbopack_context__.v({
  "className": "poppins_77351580-module__sXnczG__className",
  "variable": "poppins_77351580-module__sXnczG__variable",
});
